var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-loader loader",attrs:{"at-a-loader":""}},[_c('span',{staticClass:"loader__square"}),_c('span',{staticClass:"loader__square"}),_c('span',{staticClass:"loader__square"})])
}]

export { render, staticRenderFns }